<template>
  <div class="achievement">
    <user-info :userInfo="userInfo" :isShowFansBar="false" />
    <div class="content-bg">
      <h3>我的成就（{{ seAchievements.length }}/{{ achievements.length }}）</h3>
      <div class="achievement-bg">
        <div
          class="achievement-item"
          v-for="(item, index) in achievements"
          :key="item.title"
        >
          <van-image class="achievement-item-img" :src="item.img" />
          <span
            class="achievement-title"
            :style="{ color: item.unlocked ? colors[index] : '#707070' }"
            >{{ item.title }}</span
          >
          <div class="achievement-text">{{ item.detail }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserInfo from "./child/UserInfo";
import AttentItem from "./child/AttentItem";
import CollectItem from "./child/CollectItem";
import { getAchievements } from "network/profile";

export default {
  name: "Achievement",
  components: {
    UserInfo,
    AttentItem,
    CollectItem,
  },
  data() {
    return {
      userInfo: {},
      currentIndex: 0,
      achievements: [],
      seAchievements: [], //完成的成就
      colors: [
        "#E35259",
        "#E35289",
        "#5257E3",
        "#60AC2B",
        "#4089C1",
        "#F19E10",
        "#E352D6",
        "#8198EC",
        "#8FCF9B",
        "#FF6EAF",
      ],
    };
  },
  computed: {},
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.getAchievements();
  },
  mounted() {},
  methods: {
    itemClick(index) {
      if (this.currentIndex === index) {
        return;
      }
      this.currentIndex = index;
    },
    //我的成就
    getAchievements() {
      getAchievements().then((res) => {
        this.achievements = res.data;
        this.seAchievements = res.data.filter((item) => item.unlocked == true);
      });
    },
  },
};
</script>
<style scoped>
.achievement {
  background: #f5f5f5;
  min-height: 100vh;
}
.content-bg {
  margin: 20px 15px 0px 15px;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}
.content-bg h3 {
  font-size: 14px;
}
.achievement-bg {
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
}
.achievement-item {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.achievement-item-img {
  width: 40px;
  height: 45px;
}
.achievement-title {
  margin-top: 5px;
  font-size: 14px;
  font-weight: 600;
}
.achievement-text {
  padding: 0 3px;
  width: 108px;
  font-size: 10px;
  text-align: center;
  color: #707070;
}
</style>